import JobLayout from 'components/JobLayout';
import ApplyHeader from 'pages/StartApplication/components/ApplyHeader';
import ApplyProvider from 'pages/StartApplication/components/ApplyProvider';
import { Employment as ApplyEmployment } from '@kanda-libs/ks-apply';
import { FunctionComponent } from 'react';

const Employment: FunctionComponent = function () {
  return (
    <ApplyProvider>
      <JobLayout header={<ApplyHeader />} showJobCard={false}>
        <ApplyEmployment />
      </JobLayout>
    </ApplyProvider>
  );
};

export default Employment;
